// import Vue from 'vue/dist/vue.min.js';
import Vue from 'vue';
import Axios from 'axios';
import VueGoodTablePlugin from 'vue-good-table';
import MicroModal from 'micromodal';
//import MicroModal2 from 'micromodal';
import Swiper from 'swiper/dist/js/swiper.min.js';

Vue.use(VueGoodTablePlugin);

/* global REST_URL */
export default function initVue() {
    new Vue({
        el: '#plan',
        data: {
            linkBase: '',
            activeApartment: '',
            activeHouse: '',
            pageQuery: '',
            overlayOpen: false,
            loading: false,
            showError: false,
            showStoreButton: false,
            loaded: false,
            apartments: [],
            showAvailableOnly: true,
            fields: [],
            filterAddress: '',
            language: 'et',
            apartmentListPdfLink: '',
            translations: {
                apartment: {
                    et: 'Korter',
                    ru: 'Квартира',
                    en: 'Apartment',
                },
                address: {
                    et: 'Aadress',
                    ru: 'Адрес',
                    en: 'Address',
                },
                floor: {
                    et: 'Korrus',
                    ru: 'Этаж',
                    en: 'Floor',
                },
                rooms: {
                    et: 'Tube',
                    ru: 'Комнаты',
                    en: 'Rooms',
                },
                size: {
                    et: 'Üldpind',
                    ru: 'Общая площадь',
                    en: 'Space',
                },
                balcony: {
                    et: 'Rõdu',
                    ru: 'Балкон',
                    en: 'Balcony',
                },
                price: {
                    et: 'Hind',
                    ru: 'Цена',
                    en: 'Price',
                },
              view: {
                  et: 'Vaade',
                  ru: 'Вид',
                  en: 'View',
              },
              view_eng: {
                  et: 'Vaade',
                  ru: 'Вид',
                  en: 'View',
              },
                number: {
                    et: 'Nr',
                    ru: 'No',
                    en: 'Nr',
                },
                status: {
                    et: 'Staatus',
                    ru: 'Статус',
                    en: 'Status',
                },
            },
            apartment: {
                address: '',
                apartment_number: '',
                balcony: '',
                direction: '',
                extra: '',
                floor: '',
              view: '',
              view_eng: '',
                floorplan: {
                    link: '',
                },
                pdf: '',
                price: '',
                room_count: '',
                size: '',
                sold: false,
                sold_final: false,
              apartment_text: '',
              apartment_text_eng: '',
            },
            houseNumbers: {
              '8A': '8/1',
              '8B': '8/2',
              '8C': '8/3',
              '8D': '8/4',
              '8I': '8/9',
              '8J': '8/10',
              '8K': '8/11',
              '8L': '8/12',
              '8Q': '8/7',
              '8Z': '8/6',
              '8Y': '8/5',
              '8X': '8/8',
            },
          swiperInstances: [],
          swiperIndex: 0,
          activeGalleryIndex: 0,
        },
      computed: {
        filteredApartments() {
          if (!Array.isArray(this.apartments)) {
            return [];
          }
          return this.showAvailableOnly
            ? this.apartments.filter(
              (apartment) => apartment.acf && !apartment.acf.sold_final
            )
            : this.apartments;
        },
      },

      methods: {

            getButtonPriceListText() {
              let priceList = '';
              if (this.language === 'et-ET') {
                priceList = 'Prindi hinnakiri';
              } else if (this.language === 'en-GB') {
                priceList = 'Print price list';
              } else if (this.language === 'ru-RU') {
                priceList = 'Распечатать прайс-лист';
              }
              return priceList;
            },
            selectedBuildingVisual() {
              let vvv = this.filterAddress.toUpperCase();
              if(vvv === ''){
                return '';
              } else {
                return  this.houseNumbers[vvv];
              }

              //this.apartmentListPdfLink.test('all')
              /*let label = '';
              if (this.language === 'en-GB') {
                label = 'eng';
              } else  {
                label = 'est';
              }
              return label;*/
            },

            getHouseNumberForButton() {

              let maja = '';
              let majad = '';

              if (this.language === 'et-ET') {
                maja = 'Maja';
                majad = 'Kõik majad';
              } else if (this.language === 'en-GB') {
                maja = 'House';
                majad = 'All houses';
              } else if (this.language === 'ru-RU') {
                maja = 'дом';
                majad = 'Все дома';
              }

              let vvv = this.filterAddress.toUpperCase();
              if(vvv === ''){
                return majad;
              } else {
                return maja + ' ' + this.houseNumbers[vvv];
              }


            },

            showPrintTableModal() {
              console.log('click');
              //MicroModal2.show('modal-99')
            },

            toggleOverlay() {
              document.querySelector('.plan-overlay').classList.toggle('active');
              this.overlayOpen = !this.overlayOpen;

              //console.log('toggeling overlay')
            },
            setFilter(address) {
              this.filterAddress = address;
              console.log('address', 'address');
            },
            addSpaces(number) {
                let parts = number.toString().split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                return parts.join('.');
            },
            rowStyleFn(row) {
                return (row.acf.sold || row.acf.sold_final ? 'sold' : '');
            },
            zoomClick(event) {
              document.querySelector('.modal--viewbox-plan .image').style.backgroundImage = `url(${event.target.dataset.image})`;

              MicroModal.show('modal-viewbox-2', {
                awaitCloseAnimation: true,
                disableScroll: true,
              });
            },
            setModalImage(event) {
              document.querySelector('.modal--viewbox-plan .image').style.backgroundImage = `url(${event.target.src})`;

              MicroModal.show('modal-viewbox-2', {
                awaitCloseAnimation: true,
                disableScroll: true,
              });

              //console.log('set modal image')
            },
            formatHouseNr(houseNr) {
              return this.houseNumbers[houseNr] ? this.houseNumbers[houseNr] : houseNr;
            },
            i18n: function (text, lang = this.language) {
                if (lang === 'et-ET') {
                  lang = 'et'
                } else if (lang === 'en-GB') {
                  lang = 'en';
                } else if (lang === 'ru-RU') {
                  lang = 'ru';
                }
                return (this.translations[text][lang]) ? this.translations[text][lang] : '';
            },
            getApartments: function () {
                let that = this;

                if (this.loading) {
                    return false;
                }
                this.loading = true;

                Axios.get(REST_URL + 'kalaranna/v1/apartment' + this.pageQuery)
                    .then(function (response) {

                      //console.log('axios apartments', response);

                      that.apartments =  response.data;

                        if (that.apartments) {
                            that.showError = false;
                            that.reInit();
                        } else {
                            that.showError = true;
                            that.apartments = [];
                        }

                        that.loaded = true;
                        that.loading = false;
                        if (!that.apartments) {
                            that.apartments = [];
                        }
                    })
                    .catch(function () {
                        that.loaded = true;
                        that.loading = false;
                        if (!that.apartments) {
                            that.apartments = [];
                        }
                    });
            },
            onRowMouseover(params) {
                let niceHouse = this.houseNumbers[params.row.acf.address].replace(/\//g, '_');
                let floor = params.row.acf.floor;
                if (floor.includes('+')) {
                  floor = floor.substring(0, floor.indexOf('+')); //2 floors;
                }
                let rawSelector = '#maja-'+  niceHouse + '_' + floor + '-' + params.row.acf.apartment_number;
                $(rawSelector).css(
                  //{ fill: '#000000' },
                  { opacity: 1 }
                );

            },
            onRowMouseleave(params) {
                let niceHouse = this.houseNumbers[params.row.acf.address].replace(/\//g, '_');
                let floor = params.row.acf.floor;
                if (floor.includes('+')) {
                  floor = floor.substring(0, floor.indexOf('+')); //2 floors;
                }
                let rawSelector = '#maja-'+  niceHouse + '_' + floor + '-' + params.row.acf.apartment_number;
                $(rawSelector).css('opacity', 0);
            },
            clearCurrentUrl() {
              history.pushState(
                {},
                null,
                window.location.origin + window.location.pathname
              )
            },
            onRowClick(params) {  // params.row - row object


                if (window.location.href.includes('#')) { //vajutati reale , korista vana asi eest
                  this.clearCurrentUrl()
                }

                history.pushState(
                  {},
                  null,
                  window.location.origin + window.location.pathname + '#aid'+params.row.ID
                )





              // params.pageIndex - index of this row on the current page.

                // if ( !params.row.acf.sold ) {
                this.apartment = params.row.acf;



                let downloadUrl = '';
                if(window.location.hostname === 'magic.mixd.ee' ){
                  downloadUrl = window.origin + '/kalaranna8/wp-json/kalaranna/apartment-pdf/' +params.row.ID;
                } else {
                  downloadUrl = window.origin + '/wp-json/kalaranna/apartment-pdf/' +params.row.ID;
                }

                this.apartment.pdflink = downloadUrl;








              MicroModal.show('modal', {
                    awaitCloseAnimation: true,
                    disableScroll: true,
                    disableFocus: true,
                });

            },
            clearUrlAID(){
              this.clearCurrentUrl()
              MicroModal.close('modal');

            },
        changeTab(index) {
          this.activeGalleryIndex = index;
          this.swiperIndex = index;

          this.$nextTick(() => {
            setTimeout(() => {
              this.initGallerySwipers();
            }, 300);
          });
        },

          openGalleryModal() {
            this.$nextTick(() => {
              setTimeout(() => {
                this.initGallerySwipers();
              }, 300);
            });

            MicroModal.show('modal-gallery', {
              awaitCloseAnimation: true,
              disableScroll: true,
              disableFocus: true,
              closeTrigger: 'data-custom-close-gallery',
            });

          },
          initGallerySwipers() {
            // Ensure all previous Swipers are properly destroyed
            this.swiperInstances.forEach(swiper => {
              if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
              }
            });

            // Reset array to remove references to destroyed instances
            this.swiperInstances = [];

            this.$nextTick(() => {
              const galleryThumbs = new Swiper('.swiper-container--thumbs.index-' + this.swiperIndex, {
                spaceBetween: 10,
                slidesPerView: 14,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                breakpoints: {
                  640: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 6,
                  },
                  1200: {
                    slidesPerView: 10,
                  },
                },
                navigation: {
                  nextEl: '.swiper-button-next--thumb-' + this.swiperIndex,
                  prevEl: '.swiper-button-prev--thumb-' + this.swiperIndex,
                },
                keyboard: {
                  enabled: true,
                },
              });


              let galleryMain = new Swiper('.swiper-container--main.index-' + this.swiperIndex, {
                spaceBetween: 10,
                speed: 600,
                navigation: {
                  nextEl: '.swiper-button-next--' + this.swiperIndex,
                  prevEl: '.swiper-button-prev--' + this.swiperIndex,
                },
                thumbs: {
                  swiper: galleryThumbs,
                },
                keyboard: { enabled: true },

              });

              this.swiperInstances.push(galleryThumbs);
              this.swiperInstances.push(galleryMain);
            });
          },
          openRequestModal() {
            console.log('Request modal triggered');

            let typeString = 'Korter';

            // Check if on business plan page
            if (document.querySelector('body').classList.contains('page-template-template-businessplan')) {
              typeString = 'Äripind';
            }

            // Set CF7 email data
            document.querySelector('.modal--request .wpcf7-hidden[name="your-subject"]').value = 'Kalaranna ' + this.formatHouseNr(this.apartment.address) + ' - ' + typeString + ' ' + this.apartment.apartment_number;

            // Open the request modal using MicroModal
            MicroModal.show('modal-2', {
              awaitCloseAnimation: true,
              disableScroll: true,
              disableFocus: true,
              closeTrigger: 'data-custom-close',
            });
          },


        },
        watch: {

            'apartments'(newValue, oldValue) {  //sest korterid laetakse hiljem kui vue elutsükkel läbi saab

              if(newValue.length > 0){ //HASH IN URL, OPEN POPUP
                if(window.location.hash !== ''){

                    let apartmentWpID = parseInt(window.location.hash.replace('#aid', ''));

                    //console.log('apartmentWpID', apartmentWpID)
                    const activeApartment = newValue.find(obj => obj.ID === apartmentWpID);
                    let row = {
                      row: {
                        ID: apartmentWpID,
                        acf: activeApartment.acf,
                      },
                    }

                  this.onRowClick(row) //SET ACTIVE ROW
                }

              }
              console.log(newValue, oldValue);
            },

            'filterAddress'(newValue) { //newValue, oldValue
                let zzz = newValue.toUpperCase();
                if(zzz === ''){
                  this.apartmentListPdfLink = this.linkBase + 'all';
                } else {
                  this.apartmentListPdfLink =  this.linkBase + zzz // this.houseNumbers[zzz]; //substring   linkbase + 7
                }
                console.log('filteraadress muutus ', this.apartmentListPdfLink )


            },
        },

        mounted: function (){

          if(window.location.hostname === 'magic.mixd.ee' ){
            this.linkBase = window.origin + '/kalaranna8/wp-json/kalaranna/apartment-pdf-list/';
          } else {
            this.linkBase = window.origin + '/wp-json/kalaranna/apartment-pdf-list/';
          }

          this.apartmentListPdfLink = this.linkBase+'all';

          console.log(this.apartmentListPdfLink , 'this.apartmentListPdfLink ');

          let self = this;
          window.addEventListener('keyup', function(event) {
            if(event.key == 'Escape') {
              self.clearUrlAID();
            }
          });


        },

        created: function () {
            this.overlayOpen = false;

            this.language = document.querySelector('html').lang;

            if (document.querySelector('body').classList.contains('page-template-template-businessplan')) {
                this.pageQuery = '?business=1&timestamp=' + new Date().getTime();

                this.fields = [
                    {
                        field: 'acf.address',
                        label: this.i18n('address'),
                        sortable: true,
                    },
                    {
                        field: 'acf.apartment_number',
                        label: this.i18n('number'),
                        filterable: false,
                        type: 'number',
                    },
                    {
                        field: 'acf.floor',
                        label: this.i18n('floor'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.size',
                        label: this.i18n('size'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.price',
                        label: this.i18n('status'),
                        sortable: true,
                        type: 'number',
                    },
                  {
                    field: 'acf.view',
                    label: this.i18n('view'),
                    sortable: false,
                    type: 'text',
                  },
                  

                ];
            } else {
                this.pageQuery = '?timestamp=' + new Date().getTime();
                this.fields = [
                    {
                        field: 'acf.address',
                        label: this.i18n('address'),
                        sortable: true,
                    },
                    {
                        field: 'acf.apartment_number',
                        label: this.i18n('apartment'),
                        filterable: false,
                        type: 'number',
                    },
                    {
                        field: 'acf.floor',
                        label: this.i18n('floor'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.room_count',
                        label: this.i18n('rooms'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.size',
                        label: this.i18n('size'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.balcony',
                        label: this.i18n('balcony'),
                        sortable: true,
                        type: 'number',
                    },
                    {
                        field: 'acf.price',
                        label: this.i18n('price'),
                        sortable: true,
                        type: 'number',
                    },
                  {
                    field: 'acf.view',
                    label: this.i18n('view'),
                    sortable: false,
                    type: 'text',
                  },
                  
                ];
            }
            this.language = document.querySelector('html').getAttribute('lang');

            this.getApartments();

        },
    });
}



// WEBPACK FOOTER //
// ./scripts/util/plan.js